<template>
  <div class="header">
    <header-tag :title="$PAGE_API.home.children.staffManage.title"></header-tag>
    <div class="search">
      <input
        type="text"
        placeholder="搜索账号/姓名/手机号"
        v-model="keyword"
        @keyup.enter="searchKeyword()"
        @blur="searchKeyword()"
      />
      <a href="#" @click.prevent="searchKeyword()"
        ><img src="@/assets/img/icon/u502.png" alt=""
      /></a>
    </div>
    <div class="right">
      <a
        href="#"
        class="blue-btn"
        @click="showModals"
        v-show="showState || !total"
        >注册子账号</a
      >
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag'
import { mapActions } from 'vuex'
export default {
  name: 'emplyeeHeader',
  components: {
    HeaderTag,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      keyword: '',
      showState: false,
    }
  },
  watch: {
    total() {
      switch (this.$store.state.user.userInfo.judgeVip) {
        case 0:
          this.showState = this.total >= 32 ? false : true
          break
        case 1:
          this.showState = this.total >= 32 ? false : true
          break
        case 2:
          this.showState = this.total >= 64 ? false : true
          break
        case 3:
          this.showState = this.total >= 500 ? false : true
          break
        default:
          break
      }
    },
  },
  methods: {
    ...mapActions(['emplyee/actionSetShowOrHide', 'emplyee/actionSetTitle']),
    showModals() {
      this['emplyee/actionSetShowOrHide'](true)
      this['emplyee/actionSetTitle']('注册子账号')
    },
    searchKeyword() {
      this.$emit('listentochildevent', this.keyword)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '_style/_color.scss';
.header {
  // padding-left: 30px;
  padding: 20px 0 20px 30px;
  text-align: left;
  .search {
    display: inline-block;
    margin-left: 30px;
    input {
      width: 280px;
      height: 30px;
      border: 1px solid rgba(230, 230, 230, 1);
      font-size: 12px;
      color: #a1a1a1;
      padding-left: 10px;
    }
    a {
      display: inline-block;
      width: 60px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background: rgba(242, 242, 242, 1);
      border: 1px solid rgba(230, 230, 230, 1);
      border-left: none;
    }
  }
  .right {
    display: inline-block;
    float: right;
    padding-right: 20px;
    a {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      padding: 0;
    }
  }
}
</style>
